export const SET_TITLE = 'SET_TITLE' as const
export const SET_ERROR = 'SET_ERROR' as const
export const SET_CURRENT_CONVERSATION = 'SET_CURRENT_CONVERSATION' as const
export const SET_CONVERSATION_ID = 'SET_CONVERSATION_ID' as const
export const SET_IS_MENU_VISIBLE = 'SET_IS_MENU_VISIBLE' as const
export const SET_IS_EMPTY_CHAT = 'SET_IS_EMPTY_CHAT' as const
export const ADD_MESSAGES = 'ADD_MESSAGES' as const
export const DELETE_MESSAGE = 'DELETE_MESSAGE' as const
export const CREATE_MESSAGE = 'CREATE_MESSAGE' as const
export const CREATE_CONVERSATION = 'CREATE_CONVERSATION' as const
export const ADD_CONVERSATION_LIST = 'ADD_CONVERSATION_LIST' as const
export const SET_TOKENS_SPENT = 'SET_TOKENS_SPENT' as const
export const SET_CURRENT_TOKEN_AMOUNT = 'SET_CURRENT_TOKEN_AMOUNT' as const
export const SET_CURRENT_CHAT_CONTEXT = 'SET_CURRENT_CHAT_CONTEXT' as const
export const RESET_CURRENT_CHAT_STATE = 'RESET_CURRENT_CHAT_STATE' as const
export const SET_STREAMING_MESSAGE = 'SET_STREAMING_MESSAGE' as const
export const SET_IS_CURRENTLY_STREAMING = 'SET_IS_CURRENTLY_STREAMING' as const
export const SET_IS_CURRENTLY_FETCHING = 'SET_IS_CURRENTLY_FETCHING' as const
export const SET_TYPE_OF_VIEW = 'SET_TYPE_OF_VIEW' as const
export const SET_INTAKE_STATUS = 'SET_INTAKE_STATUS' as const
